import React from 'react';
import { map } from 'lodash';
import { Navigate, Route, Routes } from 'react-router-dom';
import { Container, Row, Col, ListGroup } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { selectCurrentUser } from '@components/Auth';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import HeaderPrimary from '@components/HeaderPrimary';
import { useToast } from '@components/ToastProvider';
import { UserStatuses } from '@models/UserProfile';

import OldDashboard from './OldDashboard';
import DashboardPage from './DashboardPage';
import Billing from './Billing';
import Policy from './Policy';
import PolicyDetails from './PolicyDetails';
import PolicyClaim from './PolicyClaim';
import PolicyRenewal from './PolicyRenewal';
import PersonalInfoPage from './PersonalInfoPage';
import PersonalInfoEditPage from './PersonalInfoEditPage';
import BillingDetails from './BillingDetails';
import InsuranceClaimListPage from './InsuranceClaimListPage';
import InsuranceClaimDetailsPage from './InsuranceClaimDetailsPage';
import PasswordPage from './PasswordPage';
import MobileNumberPage from './MobileNumberPage';
import InsurancePolicyListPage from './InsurancePolicyListPage';
import InsurancePolicyDetailsPage from './InsurancePolicyDetailsPage';
import InsurancePolicyUserDetailsPage from './InsurancePolicyUserDetailsPage';
import SearchInsurancePolicyUserPage from './SearchInsurancePolicyUserPage';
import { useActiveKey, useUserDashboard } from './hook';
import { routeUserDashboardMobileNumberPage } from './route';

const UserDashboardRoute = () => {
  const { items } = useUserDashboard();
  const activeKey = useActiveKey();
  const currentUser = useSelector(selectCurrentUser);
  const toast = useToast();

  if (activeKey !== 'mobileNumber' && currentUser?.status === UserStatuses.Pending) {
    toast.warning({ body: 'You must update mobile number to confirm your account.' });
    return <Navigate to={routeUserDashboardMobileNumberPage()} />;
  }

  return (
    <>
      <HeaderPrimary />
      <Container fluid className="my-4">
        <Row className="gy-4">
          <Col sm={3}>
            <ListGroup activeKey={activeKey}>
              {map(items, ({ key, to, icon, label }) => (
                <ListGroup.Item as={Link} action to={to} key={key} eventKey={key}>
                  <FontAwesomeIcon icon={icon} className="fa-fw me-2" />
                  {label}
                </ListGroup.Item>
              ))}
            </ListGroup>
          </Col>
          <Col sm={9}>
            <Routes>
              {/* NEW */}

              <Route index element={<DashboardPage />} />

              <Route path="insurance-policy" element={<InsurancePolicyListPage />} />
              <Route path="insurance-policy/:insurancePolicyId" element={<InsurancePolicyDetailsPage />} />
              <Route path="insurance-policy-user/:insurancePolicyUserId" element={<InsurancePolicyUserDetailsPage />} />
              <Route
                path="insurance-policy/:insurancePolicyId/insurance-policy-user/:insurancePolicyUserId/claim"
                element={<PolicyClaim />}
              />

              <Route path="search-insurance-policy-user" element={<SearchInsurancePolicyUserPage />} />

              <Route path="insurance-claim" element={<InsuranceClaimListPage />} />
              <Route path="insurance-claim/:claimableType/:claimableId" element={<InsuranceClaimDetailsPage />} />

              <Route path="password" element={<PasswordPage />} />
              <Route path="mobile-number" element={<MobileNumberPage />} />

              <Route path="personal-info" element={<PersonalInfoPage />} />
              <Route path="personal-info/edit" element={<PersonalInfoEditPage />} />

              {/* TODO: OLD, to be remove */}

              <Route path="old-dashboard" element={<OldDashboard />} />

              <Route path="policy" element={<Policy />} />
              <Route path="policy/:orderableType/:orderableId" element={<PolicyDetails />} />
              <Route path="policy/:orderableType/:orderableId/claim" element={<PolicyClaim />} />
              <Route path="policy/:orderableType/:orderableId/renewal" element={<PolicyRenewal />} />

              <Route path="billing" element={<Billing />} />
              <Route path="billing/:billingId" element={<BillingDetails />} />
            </Routes>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export { UserDashboardRoute };
